import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal, NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { ApiService } from '../../services/api.service';
import { TranslateService } from '@ngx-translate/core';
import { InformationComponent } from '../../core/information/information.component';

@Component({
  selector: 'app-download-log',
  templateUrl: './download-log.component.html',
  styleUrls: ['./download-log.component.scss']
})
export class DownloadLogComponent implements OnInit {
  currentPage = 1;
  itemsPerPage = 40;
  loading = false;
  message?: string;
  modal: NgbModalRef;
  tableData = [];
  totalItems: number;

  @Input() feature?: string;

  constructor(
    private apiService: ApiService,
    public activeModal: NgbActiveModal,
    private modalService: NgbModal,
    private translateService: TranslateService,
  ) {}

  ngOnInit() {
    this.loadCeleryResults();
  }

  loadCeleryResults(resetPageNumber = true) {
    if (!this.feature) {
      return;
    }

    if (resetPageNumber) {
      this.currentPage = 1;
    }

    this.loading = true;
    const params = {
      page: this.currentPage,
      feature: this.feature,
      page_size: this.itemsPerPage,
    }
    this.apiService.getCeleryResults(params).subscribe(
      (response) => {
        this.loading = false;
        this.tableData = response.results;
        this.totalItems = response.count;
      },
      (error) => {
        this.loading = false;
        this.totalItems = undefined;
      },
    );
  }

  pageChanged() {
    this.loadCeleryResults(false);
  }

  optionChanged() {
    this.loadCeleryResults();
  }

  downloadFile(data) {
    this.apiService.getFileFullPath(data.file_path, {need_decrypt: false}).subscribe(
      (blob: Blob) => {
        this.apiService.createDownloadFile(blob, data.filename);
      },
    );
  }

  openConfirmModal(content, data, action) {
    this.message = action === 'cancel'
      ? this.translateService.instant('DOWNLOAD-LOGS.CONFIRM-CANCEL')
      : this.translateService.instant('DOWNLOAD-LOGS.CONFIRM-DELETE')
    this.modal = this.modalService.open(content, { centered: true });
    this.modal.result.then((result) => {
      if (!result) {
        return;
      }

      const request$ = action === 'cancel'
        ? this.apiService.revokeCeleryTask(data.id)
        : this.apiService.deleteCeleryTask(data.id)

      request$.subscribe(
        () => {
          this.informUser(
            action === 'cancel'
              ? this.translateService.instant('DOWNLOAD-LOGS.SUCCESSFULLY-CANCELLED')
              : this.translateService.instant('DOWNLOAD-LOGS.SUCCESSFULLY-DELETED')
          );
          this.loadCeleryResults();
        },
        (err) => { this.informUser(); },
      )
    })
  }

  informUser(message?: string) {
    const informModal = this.modalService.open(InformationComponent, { centered: true });
    informModal.componentInstance.message = message || this.translateService.instant('ERROR.TRY-AGAIN');
  }
}



// WEBPACK FOOTER //
// /opt/app/src/app/features/download-log/download-log.component.ts